import styled, { css, keyframes } from 'styled-components';

import { Copytext } from '../../atoms/Copytext';
import Icon from '../../atoms/Icon';

export const BookmarkIconStyled = styled(Icon)`
  top: 50%;
  left: 50%;
  transform: scale(1); /* Sets default scale for the icon */
  transition: transform 0.3s ease; /* Animation for scaling */
  transform-origin: center; /* Scaling takes place around the middle */
`;

export const BookmarkWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 100%;

  &:hover {
    ${BookmarkIconStyled} {
      ${({ $defaultIconSize, $isBookmarked }) => css`
        height: ${$defaultIconSize.height}px;
        width: ${$defaultIconSize.width}px;

        ${!$isBookmarked &&
        css`
          // Hover ON
          transform: scale(1.067); /* Scales the icon by 2px */
          transition: transform 0.3s ease; /* Animation for scaling */
          transform-origin: center; /* Scaling takes place around the middle */
        `}
      `}
    }
  }
`;

export const BookmarkText = styled(Copytext)`
  margin: auto 10px;
`;

// Keyframes for the animation
const pop = keyframes`
    0% {
      opacity: 1;
      transform: translate(-50%, -50%) scale(0);
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translate(var(--x), var(--y)) scale(1.5);
    }
  `;

export const BookmarkCircle = styled.div`
  position: absolute;
  pointer-events: none;
  border-radius: 50%;
  opacity: 0;
  top: calc(50% - 10px);
  left: calc(50% - 5px);
  transform: translate(-50%, -50%);

  /* Dynamic direction of movement with CSS variables */
  --x: ${(props) => props.$coordinates.x};
  --y: ${(props) => props.$coordinates.y};

  /* Animation only start when the condition is true */
  ${(props) =>
    props.$animate &&
    css`
      animation: ${pop} 0.4s ease forwards;
    `}

  ${(props) => css`
    height: ${props.$size.height}px;
    width: ${props.$size.width}px;
    background-color: ${props.$color};
  `}
`;

export const BookmarkHeartContainer = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;
`;
